export const embedDialogTestIds = {
  root: 'embed-dialog',
  step1Instructions: 'embed-dialog-step-1-instructions',
  step2Instructions: 'embed-dialog-step-2-instructions',
  urlInput: 'embed-dialog-url-input',
  submitButton: 'embed-dialog-submit-button',
};
